<script setup lang="ts">
import CustomAlert from "@/components/custom/CustomAlert.vue";
</script>

<template>
  <div class="main">
    <CustomAlert/>
    <router-view/>
  </div>
</template>

<style lang="scss" scoped>
</style>
